export const envConfig =
{
    "calculatorBasePath": "https://dev.ignitere.firstam.com/api/calculator/",
    "calculatorPrintURL": "https://cdn.dev.direct.firstam.com/ignitere/calculator/latest/print/index.html"
}